<template>
  <admin-layout title="Galeria de vídeos" menu="Galeria de vídeos">
    <title>GALERIA DE VÍDEOS</title>
    <div class="mr-0 ml-0 p-3 row">
      <div class="col-lg-12">
        <h3>GALERIA DE VÍDEOS</h3>
      </div>
      <div class="col-lg-3 col-xs-12">
        <div
          class="form-group mb-0 has-search d-flex justify-content-end"
          style="margin-left: -3px"
        >
          <div>
            <span
              class="color-black fa fa-search ml-2 mt-2 mr-3 form-control-feedback"
            ></span>
          </div>
          <input
            type="text"
            v-model="search"
            v-on:keyup.enter="searchVideos"
            class="form-control no_border"
          />
        </div>
      </div>

      <div class="col-lg-9">
        <button
          @click="searchable = false"
          v-if="searchable"
          type="button"
          class="btn btn-info right"
        >
          <font-awesome-icon class="mr-3" icon="chevron-left" />VOLTAR A LISTA
        </button>
      </div>
    </div>
    <div class="w-100 mt-5">
      <img
        src="/images/header_galleries.png"
        alt="image_header"
        class="w-100"
      />
    </div>
    <transition name="fade" mode="out-in" appear>
      <List v-if="!searchable" />
      <div v-if="searchable">
        <div v-if="load" class="col-lg-12 center">
          <sweetalert-icon icon="loading" />
        </div>

        <div v-if="!load" class="col-lg-12">
          <h1 v-if="videos.length == 0">
            NÃO ENCONTRAMOS VÍDEOS RELACIONADOS.
          </h1>

          <Search :videos="videos" />
        </div>
      </div>
    </transition>
  </admin-layout>
</template>
<script>
import List from "@/Recruiters/Galleries/List.vue";
import Search from "@/Recruiters/Galleries/Search.vue";

export default {
  components: { List, Search },
  data: () => ({
    searchable: false,
    search: "",
    load: false,
    videos: [],
  }),
  mounted() {
    eventBus.$on("searchVideoList", (field) => {
      this.searchVideos();
    });

    eventBus.$on("chooseFormVideo", (video) => {
      this.$modal.hideAll();
      if (this.searchable) {
        eventBus.$emit("searchVideoList", true);
      } else {
        eventBus.$emit("videoIndexGallery", true);
      }
    });
  },
  methods: {
    searchVideos() {
      this.searchable = true;
      this.load = true;
      axios.get(`galleries/search?search=${this.search}`).then((response) => {
        this.load = false;
        this.videos = response.data.videos;
      });
    },
  },
};
</script>